











import { Component, Mixins } from "vue-property-decorator";
import {
  ModelEditableMixin,
} from "../../../../../../base/components/system/mixins";
import { FormatStructureEditableMixin } from "../../mixins";
import { FormatPagePropertyEditor } from "./contents";

@Component({
  components: {
    FormatPagePropertyEditor,
  },
})
export default class FormatPagePropertyEditTool extends Mixins(FormatStructureEditableMixin, ModelEditableMixin) {
}
